import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { EmptyState } from '@/components/custom/empty-state';

export function SchoolRankingChart({ data = [] }) {
  if (!data.length) {
    return (
      <EmptyState
        type="data"
        variant="plain"
        text="Nenhum dado disponível"
      />
    );
  }

  const options = {
    chart: {
      type: 'bar',
      height: Math.max(320, data.length * 42)
    },
    credits: { enabled: false },
    title: { text: null },
    legend: { enabled: false },
    xAxis: {
      categories: data.map(item => item.label),
      title: { text: null },
      labels: {
        align: 'left',
        reserveSpace: true,
        style: {
          whiteSpace: 'nowrap',
          width: 150,
          textOverflow: 'ellipsis',
          fontSize: '11px',
          color: '#5D6A86'
        }
      },
      gridLineWidth: 0,
      lineWidth: 0
    },
    yAxis: {
      min: 0,
      max: 100,
      title: { text: null },
      labels: { overflow: 'justify' },
      gridLineWidth: 1,
      lineWidth: 0
    },
    tooltip: { valueSuffix: '%' },
    plotOptions: {
      bar: {
        borderRadius: 4,
        dataLabels: {
          enabled: true,
          format: '{y}',
          style: { fontSize: '11px', fontWeight: '600', textOutline: 'none', color: '#110B3E' }
        }
      }
    },
    series: [
      {
        name: 'Média geral',
        color: '#442B8C',
        data: data.map(item => parseFloat(item.average.toFixed(2)))
      }
    ]
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  );
}
